function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 11-3.613 15.14l-.121-.065-3.645.91a.5.5 0 01-.62-.441v-.082l.014-.083.91-3.644-.063-.12a7.95 7.95 0 01-.83-2.887l-.025-.382L0 8a8 8 0 018-8zm.5 9h-3l-.09.008a.5.5 0 000 .984L5.5 10h3l.09-.008a.5.5 0 000-.984L8.5 9zm2-3h-5l-.09.008a.5.5 0 000 .984L5.5 7h5l.09-.008a.5.5 0 000-.984L10.5 6z",
  fill: "#8F90A6"
});

function SvgCommentsFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCommentsFilledIcon;